<template>
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon left color="primary">mdi-cog</v-icon>
        Configurar {{ integration.name }}
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pt-8">
        <div class="text-center mb-8">
          <img
            :src="integration.icon"
            :alt="integration.name"
            style="max-width: 250px; max-height: 30px; object-fit: contain"
          />
        </div>

        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- Apex E-commerce -->
          <template v-if="integration.provider === 'apex_ecommerce'">
            <v-text-field
              v-model="credentials.store_id"
              label="Store ID"
              outlined
              required
              :rules="[(v) => !!v || 'Store ID é obrigatório']"
            ></v-text-field>

            <v-textarea
              v-model="credentials.access_token"
              label="Access Token"
              outlined
              required
              rows="3"
              :rules="[(v) => !!v || 'Access Token é obrigatório']"
            ></v-textarea>
          </template>

          <template v-if="integration.provider === 'apex_agentes'">
            <v-textarea
              v-model="credentials.access_token"
              label="Access Token"
              outlined
              required
              rows="3"
              :rules="[(v) => !!v || 'Access Token é obrigatório']"
            ></v-textarea>
          </template>

          <!-- Outros providers - template genérico -->
          <!-- <template
            v-if="
              !['apex_ecommerce', 'apex_agentes'].includes(integration.provider)
            "
          >
            <v-alert type="info" outlined>
              Configuração para {{ integration.name }} em desenvolvimento
            </v-alert>
          </template> -->

          <v-switch v-model="status" label="Ativar integração"></v-switch>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close"> Cancelar </v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="!valid"
          @click="save"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "IntegrationConfigModal",

  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      integration: {
        name: "",
        provider: "",
        icon: "",
      },
      credentials: {},
      status: true,
    };
  },

  methods: {
    async open(integration, existingData = null) {
      this.integration = { ...integration };
      this.dialog = true;

      if (existingData && existingData.id) {
        await this.loadIntegration(existingData.id);
      } else {
        this.credentials = this.getDefaultCredentials(integration.provider);
        this.status = true;
      }
    },

    async loadIntegration(id) {
      this.loading = true;

      try {
        const response = await this.$http.show("integration/integration", id);

        if (response.integration) {
          this.credentials = response.integration.credentials
            ? { ...response.integration.credentials }
            : {};
          this.status = response.integration.status;
        }
      } catch (error) {
        this.credentials = this.getDefaultCredentials(
          this.integration.provider,
        );
        this.status = true;
      } finally {
        this.loading = false;
      }
    },

    getDefaultCredentials(provider) {
      switch (provider) {
        case "apex_ecommerce":
          return {
            store_id: "",
            access_token: "",
          };
        case "apex_agentes":
          return {
            access_token: "",
          };
        default:
          return {};
      }
    },

    close() {
      this.dialog = false;
      this.$refs.form.reset();
      this.credentials = {};
    },

    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;

      try {
        const cleanCredentials = Object.entries(this.credentials).reduce(
          (acc, [key, value]) => {
            if (value !== null && value !== undefined && value !== "") {
              acc[key] = value;
            }
            return acc;
          },
          {},
        );

        const payload = {
          name: this.integration.name,
          provider: this.integration.provider,
          credentials: cleanCredentials,
          status: this.status,
        };

        this.$emit("saved", payload);
        this.close();
      } catch (error) {
        console.error("Erro ao salvar integração:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
